<template>
  <div>
    <div class="is-padding">
      <form>
        <div class="">
          <section class="">
            <div class="columns">
              <date-picker
                :model="date"
                @input="date = $event"
                :style-version="2"
                label="Date et Heure"
                :config="dtConfig"></date-picker>
            </div>
          </section>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: 'OptionUpdateDateModal',
  props: {
    source: {
      required: true
    }
  },
  data () {
    return {
      date: null,
      minDate: null
    }
  },
  computed: {
    dtConfig () {
      return {
        altFormat: 'j/m/Y',
        altInput: true,
        dateFormat: 'Z',
        enableTime: true,
        time_24hr: true,
        minDate: this.minDate,
        inline: true,
        minuteIncrement: 1
      }
    },
    today () {
      return moment().toISOString()
    }
  },
  mounted () {
    this.date = this.source.end_date
    this.minDate = this.today
  },
  methods: {
    submitQuickview () {
      let hour = document.querySelector('.flatpickr-hour').value
      let minute = document.querySelector('.flatpickr-minute').value
      let newDate = moment(this.date).set({ 'hour': hour, 'minute': minute })
      newDate = moment(newDate).toISOString()
      this.date = newDate
      this.$emit('submitQuickview', { option: this.source, date: this.date })
    }
  }
}
</script>
